"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraInactiveScreen = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const analytics_1 = require("@streem/analytics");
const __1 = require("../../..");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const operators_1 = require("rxjs/operators");
function CameraInactiveScreen({ videoController, mobileDisplay, determinedUIProperties, constrainContainerToCanvas, aspectRatioConversion, }) {
    var _a, _b, _c;
    const theme = (0, ui_react_1.useTheme)();
    const [connected] = (0, __1.useObservable)(videoController.connected);
    const [enabled] = (0, __1.useObservable)(videoController.muted.pipe((0, operators_1.map)(muted => !muted)));
    const [backgrounded] = (0, __1.useObservable)(videoController.backgrounded);
    const [paused] = (0, __1.useObservable)(videoController.paused);
    const [cameraSubject] = (0, __1.useObservable)(videoController.cameraSubject);
    const inPip = (_a = determinedUIProperties === null || determinedUIProperties === void 0 ? void 0 : determinedUIProperties.switches.inPip) !== null && _a !== void 0 ? _a : false;
    (0, react_1.useEffect)(() => {
        if (paused) {
            const pauseMessageScreenId = `call: ${mobileDisplay ? 'host' : 'spectator'} remote participant video paused`;
            // This component displays multiple messages but for analytics purposes,
            // we only want to record the view when chime has paused the remote video
            (0, analytics_1.recordScreenViewed)(pauseMessageScreenId);
        }
    }, [paused, mobileDisplay]);
    if (!connected ||
        (enabled && !backgrounded && !paused) ||
        (inPip && videoController.ownerIsLocalUser && !mobileDisplay)) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    return ((0, jsx_runtime_1.jsxs)(Container, Object.assign({ mobileDisplay: mobileDisplay, inPip: inPip, enabled: enabled && !backgrounded, worldFacingMobileDisplayCameraOff: videoController.ownerIsLocalUser &&
            mobileDisplay &&
            inPip &&
            cameraSubject === streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_WORLD, constrainContainerToCanvas: constrainContainerToCanvas, aspectRatioConversion: aspectRatioConversion, isFullScreenDesktop: !videoController.ownerIsLocalUser &&
            !mobileDisplay &&
            cameraSubject === streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_WORLD }, { children: [!paused &&
                ((determinedUIProperties === null || determinedUIProperties === void 0 ? void 0 : determinedUIProperties.switches.showAvatar) ? ((0, jsx_runtime_1.jsx)(ui_react_1.Avatar, { src: determinedUIProperties === null || determinedUIProperties === void 0 ? void 0 : determinedUIProperties.properties.avatarSrc, displayName: determinedUIProperties.properties.displayName, size: determinedUIProperties.switches.inPip ? 'small' : 'xlarge' })) : ((0, jsx_runtime_1.jsx)(ui_react_1.AppIcon, { name: (_b = determinedUIProperties === null || determinedUIProperties === void 0 ? void 0 : determinedUIProperties.properties.icon) !== null && _b !== void 0 ? _b : 'CameraOffIcon', color: theme.colors.grey30, size: (determinedUIProperties === null || determinedUIProperties === void 0 ? void 0 : determinedUIProperties.properties.message) ? 'large' : 'medium' }))), (determinedUIProperties === null || determinedUIProperties === void 0 ? void 0 : determinedUIProperties.properties.message) && ((0, jsx_runtime_1.jsx)(MessageContainer, Object.assign({ paused: paused || false, mobileDisplay: mobileDisplay, inPip: inPip }, { children: (0, jsx_runtime_1.jsx)(MessageText, Object.assign({ as: "p", size: 'medium', paused: paused || false, mobileDisplay: mobileDisplay, inPip: inPip, determinedUIProperties: determinedUIProperties }, { children: (_c = determinedUIProperties === null || determinedUIProperties === void 0 ? void 0 : determinedUIProperties.properties.message) !== null && _c !== void 0 ? _c : '' })) })))] })));
}
exports.CameraInactiveScreen = CameraInactiveScreen;
const MessageContainer = (0, ui_react_1.styled)(ui_react_1.Box)(({ paused, mobileDisplay, inPip }) => ({
    width: paused && !mobileDisplay ? '335px' : '100%',
    marginTop: paused && mobileDisplay ? '0px' : '16px',
    paddingLeft: paused && inPip ? '0px' : '16px',
    paddingRight: paused && inPip ? '0px' : '16px',
}));
MessageContainer.displayName = 'MessageContainer';
const MessageText = (0, ui_react_1.styled)(ui_react_1.AppText)(({ theme, determinedUIProperties }) => {
    var _a, _b;
    return ({
        textAlign: 'center',
        fontSize: (_a = determinedUIProperties === null || determinedUIProperties === void 0 ? void 0 : determinedUIProperties.styles.fontSize) !== null && _a !== void 0 ? _a : '1rem',
        color: (_b = determinedUIProperties === null || determinedUIProperties === void 0 ? void 0 : determinedUIProperties.styles.fontColor) !== null && _b !== void 0 ? _b : theme.colors.grey40,
    });
});
const Container = (0, ui_react_1.styled)(ui_react_1.Column)(
// @ts-ignore
({ mobileDisplay, enabled, worldFacingMobileDisplayCameraOff, constrainContainerToCanvas, aspectRatioConversion, inPip, isFullScreenDesktop, theme, }) => {
    const sharedStyles = {
        top: 0,
        position: 'absolute',
        zIndex: 3,
        userSelect: 'none',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: constrainContainerToCanvas
            ? `calc(var(--auto-grid-height) * ${aspectRatioConversion})`
            : '100%',
        backgroundColor: worldFacingMobileDisplayCameraOff ? undefined : theme.colors.grey90,
        border: `${enabled ? 0 : '1px'} solid ${theme.colors.grey80}`,
        color: theme.colors.grey40,
    };
    // if it's on mobile AND in a pip --- grey border + 10px border radius
    if (mobileDisplay && inPip) {
        return Object.assign({ borderRadius: '10px' }, sharedStyles);
    }
    // if it's on mobile and NOT in a pip -- no border, no border radius
    if (mobileDisplay && !inPip) {
        return Object.assign(Object.assign({}, sharedStyles), { borderRadius: undefined, border: 'none' });
    }
    // if it's NOT on mobile -- grey border + 20px border radius, except for when video is world facing in EV2
    return Object.assign(Object.assign({}, sharedStyles), { borderRadius: isFullScreenDesktop ? '0px' : '20px' });
});
//# sourceMappingURL=camera_inactive_screen.js.map